export enum ContentControlLiveSourceType {
  Channel,
}
